import { useIntl } from "react-intl";
import { useSelector, shallowEqual } from "react-redux";

import { Button, Col, Form, Row, Select } from "antd";

import { moment } from "../../../helpers/moment";

const { Option } = Select;

const Loader = ({ form, loading, loadData }) => {
  const intl = useIntl();

  const hotels = useSelector((state) => state.hotelsCRM.hotels, shallowEqual);

  return (
    <Form
      layout="vertical"
      name="offers-loader"
      form={form}
      onFinish={loadData}
      initialValues={{ fromTo: [moment(), moment().add(2, "years")] }}
    >
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={6} xl={6}>
          <Form.Item name="_hotel" label={intl.formatMessage({ id: "hotel" })}>
            <Select
              showSearch
              optionFilterProp="children"
              style={{ width: "100%" }}
              placeholder={intl.formatMessage({ id: "selectHotel" })}
              allowClear
            >
              {hotels.map((hotel) => (
                <Option key={hotel._id} value={hotel._id}>
                  {hotel.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        {/* <Col xs={24} sm={24} md={24} lg={12} xl={6} xxl={6}>
          <Form.Item name="fromTo" label={intl.formatMessage({ id: "dates" })}>
            <RangePicker
              allowClear
              format="DD/MM/YYYY"
              placeholder={[intl.formatMessage({ id: "from" }), intl.formatMessage({ id: "to" })]}
              style={{ width: "100%" }}
              defaultValue={[moment(), moment().add(2, "years")]}
            />
          </Form.Item>
        </Col> */}
        <Col xs={24} sm={24} md={24} lg={12} xl={4} xxl={4}>
          <Form.Item label={intl.formatMessage({ id: "actions" })}>
            <Button disabled={loading} type="primary" htmlType="submit" style={{ marginRight: 8 }}>
              {intl.formatMessage({ id: "search" })}
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default Loader;
